import React from 'react';

export interface IconProps {
  size?: number;
  className?: string;
  color?: string;
}

export const IconMoon: React.FC<IconProps> = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    {/* Standard crescent moon shape - recognizable and clean */}
    {/* Using stroke for better visibility in both light and dark themes */}
    <path
      d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
      fill={color}
      stroke={color}
      strokeWidth="0.5"
    />
  </svg>
);
